/** @license React v16.12
 * Dashboard.js
 *
 * Copyright (c) iGreenMarketing and its affiliates.
 *
 * This source file is subject to the EULA
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://www.igreenmarketing.com/LICENSE.txt
 */

import React, { Component } from "react";
import Paper from '@material-ui/core/Paper';
import Typography from "@material-ui/core/Typography";

import {
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';
import auth from 'Auth';
import './Dashboard.scss';

// Shared layouts
import { Dashboard as DashboardLayout } from "layouts";

// Externals
import PropTypes from 'prop-types';
import { Subscription } from "react-apollo";
import {
  getLeadsLastHourByQuote,
  getLeadsLast7DaysByQuote,
  getLeadsLast30DaysByQuote,
  getAdminLeadsLastHourByQuote,
  getAdminLeadsLast7DaysByQuote,
  getAdminLeadsLast30DaysByQuote,
  getLeadsLastHourByCatalog,
  getAdminLeadsLastHourByCatalog,
  getLeadsLast7DaysByCatalog,
  getLeadsLast30DaysByCatalog,
  getAdminLeadsLast7DaysByCatalog,
  getAdminLeadsLast30DaysByCatalog,
  getAdminWarrantyClaimsUnderReview,
  getAdminWarrantyClaimsApproved,
  getAdminWarrantyClaimsDenied,
  getAdminContactRequestsLast30
} from "../../queries";

// Material helpers
import { withStyles } from '@material-ui/core';
// Material components
import { Grid } from '@material-ui/core';
import Messages from "components/Messages";
import MessagePopup from "components/MessagePopup";
import { GET_ADMIN_CO_OP_REQUESTS_DATA, GET_ADMIN_CO_OP_REQUESTS_DATAS, GET_ADMIN_CO_OP_REQUESTS_DATA_STATUS } from "pages/Administration/CoopRequests/queries";

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing(4),
    fontSize: '14px',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '80%',
    },

  },
  item: {
    height: '100%'
  },
  dashBoardStats: {
    padding: '0.5em 2em'
  },
  label: {
    flex: 'initial'
  },
  title: {
    fontSize: '21px',
    textTransform: 'uppercase',
    padding: '24px 0px'
  }
});

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMessage: false,
      editDetail: null
    };
  }

  toggleIsMessage = () => {
    this.setState({ isMessage: !this.state.isMessage });
  };

  setEditDetail = (detail) => {
    this.setState({ editDetail: detail });
  };

  render() {
    const { classes } = this.props;
    let isAdmin = false;
    if (auth.getRole() !== undefined) isAdmin = auth.getRole().toLowerCase();
    function formatValue(item) {
      return item.count;
    }
    return (
      <div>
        <DashboardLayout title="Dashboard">
          <div className={classes.root} >
            <Grid container spacing={4} direction="row" style={{ width: "70%", maxWidth: "70%", margin: "0px auto" }}>
              {isAdmin !== "admin" &&
                <Grid item lg={12} sm={12} xl={12} xs={12} className={classes.dashBoardStats}>
                  <Paper className={classes.paper} >
                    <Typography align="center" variant="h4" className={classes.title} style={{ padding: "20px", position: "relative" }} >Messages</Typography>
                    <div className="message-listingArea"><Messages isMessage={this.state.isMessage} toggleIsMessage={this.toggleIsMessage} isAdmin={isAdmin} /></div>
                  </Paper>
                </Grid>
              }
              <Grid item lg={6} sm={6} xl={6} xs={12} className={classes.dashBoardStats} align="center">
                <Paper className={classes.paper}>
                  <Typography align="center" className={classes.title}>Quote Leads</Typography>
                  <List className="dashBoardList">
                    <ListItem alignItems="center">
                      <ListItemText className={classes.label} primary="Received In The Last Hour:" />
                      {isAdmin === "admin" ? (
                        <Subscription subscription={getAdminLeadsLastHourByQuote}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_leads_last_hr_by_quote.length > 0) ? data.admin_leads_last_hr_by_quote.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      ) : (
                        <Subscription subscription={getLeadsLastHourByQuote}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.leads_last_hr_by_quote.length > 0) ? data.leads_last_hr_by_quote.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      )}
                    </ListItem>

                    <ListItem>
                      <ListItemText primary="Received In The Last 7 Days:" />
                      {isAdmin === "admin" ? (
                        <Subscription subscription={getAdminLeadsLast7DaysByQuote}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_leads_last_7days_by_quote.length > 0) ? data.admin_leads_last_7days_by_quote.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      ) : (
                        <Subscription subscription={getLeadsLast7DaysByQuote}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.leads_last_7days_by_quote.length > 0) ? data.leads_last_7days_by_quote.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      )}
                    </ListItem>
                    <ListItem>
                      <ListItemText primary="Responded To In Last 30 Days:" />
                      {isAdmin === "admin" ? (
                        <Subscription subscription={getAdminLeadsLast30DaysByQuote}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_leads_last_30days_by_quote.length > 0) ? data.admin_leads_last_30days_by_quote.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      ) : (
                        <Subscription subscription={getLeadsLast30DaysByQuote}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.leads_last_30days_by_quote.length > 0) ? data.leads_last_30days_by_quote.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      )}</ListItem>
                  </List>
                </Paper>
              </Grid>
              <Grid item lg={6} sm={6} xl={6} xs={12} className={classes.dashBoardStats} align="center">
                <Paper className={classes.paper}>
                  <Typography align="center" className={classes.title}>Catalog Leads</Typography>
                  <List className="dashBoardList">
                    <ListItem><ListItemText className={classes.label} primary="Received In The Last Hour: " />
                      {isAdmin === "admin" ? (
                        <Subscription subscription={getAdminLeadsLastHourByCatalog}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_leads_last_hr_by_catalog.length > 0) ? data.admin_leads_last_hr_by_catalog.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      ) : (
                        <Subscription subscription={getLeadsLastHourByCatalog}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.leads_last_hr_by_catalog.length > 0) ? data.leads_last_hr_by_catalog.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      )}
                    </ListItem>
                    <ListItem><ListItemText primary="Received In The Last 7 Days: " />
                      {isAdmin === "admin" ? (
                        <Subscription subscription={getAdminLeadsLast7DaysByCatalog}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_leads_last_7days_by_catalog.length > 0) ? data.admin_leads_last_7days_by_catalog.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      ) : (
                        <Subscription subscription={getLeadsLast7DaysByCatalog}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.leads_last_7days_by_catalog.length > 0) ? data.leads_last_7days_by_catalog.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      )}  </ListItem>
                    <ListItem>
                      <ListItemText primary="Responded To In Last 30 Days: " />
                      {isAdmin === "admin" ? (
                        <Subscription subscription={getAdminLeadsLast30DaysByCatalog}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_leads_last_30days_by_catalog.length > 0) ? data.admin_leads_last_30days_by_catalog.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      ) : (
                        <Subscription subscription={getLeadsLast30DaysByCatalog}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.leads_last_30days_by_catalog.length > 0) ? data.leads_last_30days_by_catalog.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      )} </ListItem>
                  </List>
                </Paper>
              </Grid>
              {isAdmin === "admin" ? (
                <Grid item lg={6} sm={6} xl={6} xs={12} className={classes.dashBoardStats} align="center">
                  <Paper className={classes.paper}>
                    <Typography align="center" className={classes.title}>Warranty Clams Status</Typography>
                    <List className="dashBoardList">
                      <ListItem alignItems="center">
                        <ListItemText className={classes.label} primary="Warranty Claims that need review:" />

                        <Subscription subscription={getAdminWarrantyClaimsUnderReview}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_warranty_claims_under_review.length > 0) ? data.admin_warranty_claims_under_review.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Total Accepted Warranty Claims:" />
                        <Subscription subscription={getAdminWarrantyClaimsApproved}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_warranty_claims_approved.length > 0) ? data.admin_warranty_claims_approved.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Total Denied Warranty Claim:" />
                        <Subscription subscription={getAdminWarrantyClaimsDenied}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_warranty_claims_denied.length > 0) ? data.admin_warranty_claims_denied.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription></ListItem>
                    </List>
                  </Paper>
                </Grid>
              ) : (
                ""
              )}
              {isAdmin === "admin" ? (
                <Grid item lg={6} sm={6} xl={6} xs={12} className={classes.dashBoardStats} align="center">
                  <Paper className={classes.paper}>
                    <Typography align="center" className={classes.title}>Contact Us Requests</Typography>
                    <List className="dashBoardList">
                      <ListItem><ListItemText className={classes.label} primary="Responded To In Last 30 Days: " />
                        <Subscription subscription={getAdminContactRequestsLast30}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_contact_request_last_hr.length > 0) ? data.admin_contact_request_last_hr.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                      <ListItem><ListItemText primary="" /></ListItem>
                      <ListItem><ListItemText primary="" /></ListItem>
                    </List>
                  </Paper>
                </Grid>
              ) : (
                ""
              )}

              {isAdmin === "admin" ? (
                <Grid item lg={6} sm={6} xl={6} xs={12} className={classes.dashBoardStats} align="center">
                  <Paper className={classes.paper}>
                    <Typography align="center" className={classes.title}>CO-OP ADVERTISING</Typography>
                    <List className="dashBoardList">
                      <ListItem alignItems="center">
                        <ListItemText className={classes.label} primary="TOTAL SPENT:" />
                        <Subscription subscription={getAdminWarrantyClaimsUnderReview}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_warranty_claims_under_review.length > 0) ? data.admin_warranty_claims_under_review.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="REMAINING BALANCE:" />
                        <Subscription subscription={getAdminWarrantyClaimsApproved}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data.admin_warranty_claims_approved.length > 0) ? data.admin_warranty_claims_approved.map(formatValue) : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="TOTAL ADS SUBMITTED:" />
                        <Subscription subscription={GET_ADMIN_CO_OP_REQUESTS_DATAS}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data?.co_op_requests?.length > 0) ? data?.co_op_requests?.length : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="NEW" />
                        <Subscription subscription={GET_ADMIN_CO_OP_REQUESTS_DATA_STATUS} variables={{ status: "new" }}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data?.co_op_requests?.length > 0) ? data?.co_op_requests?.length : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="PENDING" />
                        <Subscription subscription={GET_ADMIN_CO_OP_REQUESTS_DATA_STATUS} variables={{ status: "pending" }}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data?.co_op_requests?.length > 0) ? data?.co_op_requests?.length : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="DENIED" />
                        <Subscription subscription={GET_ADMIN_CO_OP_REQUESTS_DATA_STATUS} variables={{ status: "denied" }}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data?.co_op_requests?.length > 0) ? data?.co_op_requests?.length : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="APPROVED" />
                        <Subscription subscription={GET_ADMIN_CO_OP_REQUESTS_DATA_STATUS} variables={{ status: "approved" }}>
                          {({ loading, error, data }) => {
                            if (loading) return <p className="value">Loading...</p>;
                            if (error) {
                              //console.log(error)
                              return <p className="value">Error...</p>;
                            }
                            return (
                              <div className="value">
                                {(!loading && data?.co_op_requests?.length > 0) ? data?.co_op_requests?.length : '0'}
                              </div>
                            );
                          }}
                        </Subscription>
                      </ListItem>
                    </List>
                  </Paper>
                </Grid>
              ) : (
                ""
              )}

              {isAdmin === "admin" &&
                <Grid item lg={12} sm={12} xl={12} xs={12} className={classes.dashBoardStats}>
                  <Paper className={classes.paper}>
                    <Typography align="center" className={classes.title}>Messages</Typography>
                    <Grid container>
                      <div className="message-listingArea"><Messages isMessage={this.state.isMessage} toggleIsMessage={this.toggleIsMessage} isAdmin={isAdmin} setEditDetail={this.setEditDetail} editDetail={this.state.editDetail} /></div>
                      <div style={{ padding: "10px 25px", width: "100%" }}><MessagePopup isMessage={this.state.isMessage} toggleIsMessage={this.toggleIsMessage} editDetail={this.state.editDetail} setEditDetail={this.setEditDetail} /></div>
                    </Grid>
                  </Paper>
                </Grid>
              }
            </Grid>
          </div>
        </DashboardLayout >
      </div >
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Dashboard);
